import { Component, ElementRef } from '@angular/core';
import { BaseDynamicListDesignerComponent } from './base.dynamic.list.component';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import { RuleAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';

@Component({
    selector: 'sx-async-quotationresult-designer',
    templateUrl: './quotationResultAsyncDesigner.component.html'
})

export class SxAsyncQuotationResultDesigner extends BaseDynamicListDesignerComponent {
    interactionRules: DesignerSelectItem[] = [];

    constructor(container: ElementRef) {
        super(container);
        this.type='SxAsyncQuoteResult'
    }

    get jsonListProperty(): string {
        return 'customButtons';
    }

    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.selectedOptionRule = '';
    }

    loadState(rootBranch: any) {
        super.loadState(rootBranch);
        this.controlContext.selectedOptionRule = rootBranch['selectedOptionRule'];
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();
        info.selectedOptionRule = this.attributes
            .find(item => item.name === 'selectedOptionRule')
            .value;
        return info;
    }
    buildAttributes(): void {
        super.buildAttributes();

        this.interactionRules = this.designerContext.product.interactionRules;
        const selectedOptionRuleValue = 
            new RuleAttribute(this.controlContext, this.interactionRules, 'selectedOptionRule', 'SELECTED_OPTIONRULE');

        this.attributes.push(selectedOptionRuleValue);
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/quotationResultAsyncDesigner.component.ts